
import { CenteredMessage, GraphQLErrorCode } from '@tableau/data-catalog-shared';
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import { lineagePanelBodyWithError, LoadingErrorCode, LoadingErrorMessage } from './ViewerPaneStyles';

export interface LoadingFailedWidgetProps {
  readonly onRetryRequested?: () => void;
  readonly errorCode: GraphQLErrorCode | null;
}

export class LoadingFailedWidget extends React.Component<LoadingFailedWidgetProps> {

  private headlineForErrorCode(errorCode: GraphQLErrorCode | null): string {
    const genericError = Messages.Error();
    if (errorCode === null) {
      return genericError;
    }

    switch (errorCode) {
      case 'BACKFILL_RUNNING':
        return Messages.DataDetailsBackfillRunningHeadline();
      case 'RATE_EXCEEDED':
        return Messages.DataDetailsRateExceededHeadline();
      case 'TIME_LIMIT_EXCEEDED':
        return Messages.DataDetailsTimeLimitExceededHeadline();
      case 'NODE_LIMIT_EXCEEDED':
        return Messages.DataDetailsNodeLimitExceededHeadline();
      case 'INGESTION_FAILED':
      case 'INTERNAL_SERVER_ERROR':
      case 'FEATURE_DISABLED':
      default:
        return genericError;
    }
  }

  private detailsForErrorCode(errorCode: GraphQLErrorCode | null): string {
    const genericError = Messages.DataDetailsGenericErrorDetails();

    if (errorCode === null) {
      return genericError;
    }

    switch (errorCode) {
      case 'BACKFILL_RUNNING':
        return Messages.DataDetailsBackfillRunningDetails();
      case 'INGESTION_FAILED':
        return Messages.DataDetailsIngestionFailedDetails();
      case 'RATE_EXCEEDED':
        return Messages.DataDetailsRateExceededDetails();
      case 'TIME_LIMIT_EXCEEDED':
        return Messages.DataDetailsTimeLimitExceededDetails();
      case 'NODE_LIMIT_EXCEEDED':
        return Messages.DataDetailsNodeLimitExceededDetails();
      case 'INTERNAL_SERVER_ERROR':
        return Messages.DataDetailsInternalServerErrorDetails();
      case 'FEATURE_DISABLED':
        return Messages.ErrorFeatureDisabled();
      default:
        return genericError;
    }
  }

  public render(): JSX.Element {
    return (
      <div className={lineagePanelBodyWithError}>
        <CenteredMessage message={this.headlineForErrorCode(this.props.errorCode)} />
        <LoadingErrorMessage>
          {this.detailsForErrorCode(this.props.errorCode)}
        </LoadingErrorMessage>
        <LoadingErrorCode>
          {this.props.errorCode}
        </LoadingErrorCode>
        {
          // Only include a retry button if we have a handler for it.
        }
        {this.props.onRetryRequested
          ? <ButtonWidget
            buttonType={ButtonType.Outline}
            testId='retry-load-button'
            handleClick={this.props.onRetryRequested}
          >
            {Messages.LoadingFailedButtonText()}
          </ButtonWidget>
          : null
        }
      </div>
    );
  }
}
